import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=34c192a6&scoped=true"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c192a6",
  null
  
)

export default component.exports